import React, { Component } from "react";
import { PageHeader, Tag, notification, Space, Typography, Select } from "antd";
import { PlusOutlined, SettingOutlined, EyeOutlined, FormOutlined, BarChartOutlined } from "@ant-design/icons";
import {
  ButtonItem,
  HeaderActions,
  InputNumberItem,
  SubHeaderItem,
  TableItemDinamico,
  SegmentedItem,
  RangePickerItem,
  SelectPlantillasEvaluacionItem,
  SelectItem,
  ModalItem,
} from "../../../Components/Items";
import SelectProveedoresItem from "../../../Components/SelectProveedoresItem";
import ModalLlenarEvaluacion from "./Components/ModalLlenarEvaluacion";
import ModalVerEvaluacion from "./Components/ModalVerEvaluacion";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";

const { Text } = Typography;

const colorEstado = {
  pendiente: "orange",
  borrador: "blue",
  completada: "green",
};

const FRECUENCIAS = [
  { value: "mensual", label: "Mensual" },
  { value: "trimestral", label: "Trimestral" },
  { value: "semestral", label: "Semestral" },
  { value: "anual", label: "Anual" },
];

class EvaluacionProveedores extends Component {
  tableRef = null;

  state = {
    evaluaciones: [],
    loading: false,
    totalRecords: 0,
    estadoFiltro: "todas",
    fechaFiltro: null,
    // Filtros del listado (independientes de los del modal "Nueva Evaluación").
    filtroProveedorId: null,
    filtroTipoProveedorId: null,
    filtroPlantillaId: null,

    modalLlenarVisible: false,
    modalVerVisible: false,
    evaluacionActivaId: null,

    modalNuevaVisible: false,
    proveedorNuevoId: null,
    plantillaNuevaId: null,
    tipoProveedorFiltroId: null,
    frecuenciaNueva: "trimestral",
    diaNuevo: 1,
    usuarioNotificarNuevoId: null,
    creando: false,
    creandoProgramacion: false,
    tiposDeProveedor: [],
    usuariosEmpresa: [],
  };

  componentDidMount() {
    axios
      .post(
        "tiposdeproveedores/selectTodosTiposDeProveedores",
        { empresaId: this.props.empresaId, valor: 1 },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ tiposDeProveedor: res.data });
      })
      .catch(() => {});

    axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ usuariosEmpresa: res.data });
      })
      .catch(() => {});
  }

  obtenerFiltrosActuales = () => {
    const { estadoFiltro, fechaFiltro, filtroProveedorId, filtroTipoProveedorId, filtroPlantillaId } =
      this.state;
    const [inicio, fin] = fechaFiltro || [];
    return {
      estadoEvaluacion: estadoFiltro,
      proveedorId: filtroProveedorId,
      tipoProveedorId: filtroTipoProveedorId,
      plantillaId: filtroPlantillaId,
      fechaInicio: inicio?.format("YYYY-MM-DD"),
      fechaFin: fin?.format("YYYY-MM-DD"),
    };
  };

  fetchData = (params) => {
    this.setState({ loading: true });
    axios
      .post(
        "evaluacionesProveedor/selectEvaluaciones",
        { ...params, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ evaluaciones: res.data.data, totalRecords: res.data.totalRecords });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al cargar las evaluaciones." }))
      .finally(() => this.setState({ loading: false }));
  };

  handleFechaChange = (rango) => {
    this.setState({ fechaFiltro: rango }, () => {
      if (this.tableRef) this.tableRef.updateExternalFilters(this.obtenerFiltrosActuales());
    });
  };

  handleEstadoChange = (value) => {
    this.setState({ estadoFiltro: value }, () => {
      if (this.tableRef) this.tableRef.updateExternalFilters(this.obtenerFiltrosActuales());
    });
  };

  handleFiltroProveedorChange = (value) => {
    this.setState({ filtroProveedorId: value ?? null }, () => {
      if (this.tableRef) this.tableRef.updateExternalFilters(this.obtenerFiltrosActuales());
    });
  };

  handleFiltroTipoProveedorChange = (value) => {
    this.setState({ filtroTipoProveedorId: value ?? null }, () => {
      if (this.tableRef) this.tableRef.updateExternalFilters(this.obtenerFiltrosActuales());
    });
  };

  handleFiltroPlantillaChange = (value) => {
    this.setState({ filtroPlantillaId: value ?? null }, () => {
      if (this.tableRef) this.tableRef.updateExternalFilters(this.obtenerFiltrosActuales());
    });
  };

  abrirLlenar = (id) => {
    this.setState({ modalLlenarVisible: true, evaluacionActivaId: id });
  };

  cerrarLlenar = () => {
    this.setState({ modalLlenarVisible: false, evaluacionActivaId: null });
  };

  onExitoLlenado = () => {
    this.cerrarLlenar();
    if (this.tableRef) this.tableRef.updateExternalFilters(this.obtenerFiltrosActuales());
  };

  abrirVer = (id) => {
    this.setState({ modalVerVisible: true, evaluacionActivaId: id });
  };

  cerrarVer = () => {
    this.setState({ modalVerVisible: false, evaluacionActivaId: null });
  };

  abrirNueva = () => {
    this.setState({
      modalNuevaVisible: true,
      proveedorNuevoId: null,
      plantillaNuevaId: null,
      tipoProveedorFiltroId: null,
      frecuenciaNueva: "trimestral",
      diaNuevo: 1,
      usuarioNotificarNuevoId: null,
    });
  };

  cambiarTipoProveedorFiltro = (value) => {
    // Cambiar el tipo invalida el proveedor/plantilla ya elegidos
    this.setState({
      tipoProveedorFiltroId: value ?? null,
      proveedorNuevoId: null,
      plantillaNuevaId: null,
    });
  };

  cerrarNueva = () => {
    this.setState({ modalNuevaVisible: false });
  };

  // "Crear" solo registra la programación en el Proveedor, no crea la evaluación ahora
  crearProgramacion = () => {
    const { proveedorNuevoId, plantillaNuevaId, frecuenciaNueva, diaNuevo, usuarioNotificarNuevoId } =
      this.state;
    if (!proveedorNuevoId || !plantillaNuevaId || !diaNuevo) {
      return notification.warning({
        message: "Selecciona un proveedor, una plantilla y el día del mes.",
      });
    }

    this.setState({ creandoProgramacion: true });
    axios
      .post(
        "evaluacionesProveedor/agregarProgramacion",
        {
          proveedorId: proveedorNuevoId,
          plantillaId: plantillaNuevaId,
          dia: diaNuevo,
          frecuencia: frecuenciaNueva,
          usuarioNotificarId: usuarioNotificarNuevoId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          this.cerrarNueva();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al programar la evaluación." }))
      .finally(() => this.setState({ creandoProgramacion: false }));
  };

  crearEvaluacion = () => {
    const { proveedorNuevoId, plantillaNuevaId, frecuenciaNueva } = this.state;
    if (!proveedorNuevoId || !plantillaNuevaId) {
      return notification.warning({ message: "Selecciona un proveedor y una plantilla." });
    }

    this.setState({ creando: true });
    axios
      .post(
        "evaluacionesProveedor/crearEvaluacionManual",
        {
          proveedorId: proveedorNuevoId,
          plantillaId: plantillaNuevaId,
          frecuencia: frecuenciaNueva,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          this.cerrarNueva();
          if (this.tableRef) this.tableRef.updateExternalFilters(this.obtenerFiltrosActuales());
          this.abrirLlenar(res.data.evaluacion._id);
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al crear la evaluación." }))
      .finally(() => this.setState({ creando: false }));
  };

  render() {
    const columnas = [
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        ellipsis: true,
      },
      {
        title: "Plantilla",
        dataIndex: "plantillaNombre",
        ellipsis: true,
        render: (nombre, record) => `${nombre} (v${record.plantillaVersionNumero})`,
      },
      {
        title: "Periodo",
        dataIndex: "periodo",
        width: 120,
        render: (periodo) => periodo?.etiqueta || "-",
      },
      {
        title: "Estado",
        dataIndex: "estadoEvaluacion",
        width: 110,
        render: (estado) => <Tag color={colorEstado[estado]}>{estado}</Tag>,
      },
      {
        title: "Fecha de Llenado",
        dataIndex: "fechaLlenado",
        width: 150,
        render: (fecha) => (fecha ? moment(fecha).format("DD/MM/YYYY HH:mm") : "-"),
      },
      {
        title: "Calificación",
        dataIndex: "resultado",
        width: 220,
        render: (resultado) =>
          resultado?.calificacionFinal !== null && resultado?.calificacionFinal !== undefined ? (
            <Space>
              <Text strong>{resultado.calificacionFinal}</Text>
              <Tag color={resultado.clasificacionColor || "default"}>{resultado.clasificacion}</Tag>
            </Space>
          ) : (
            <Text type="secondary">-</Text>
          ),
      },
      {
        title: "Acciones",
        key: "acciones",
        width: 110,
        align: "center",
        render: (_, record) => (
          <Space>
            {record.estadoEvaluacion !== "completada" ? (
              <ButtonItem
                azul
                size="small"
                icon={<FormOutlined />}
                onClick={() => this.abrirLlenar(record._id)}
                tooltip="Llenar"
              />
            ) : (
              <ButtonItem
                blanco
                size="small"
                icon={<EyeOutlined />}
                onClick={() => this.abrirVer(record._id)}
                tooltip="Ver"
              />
            )}
          </Space>
        ),
      },
    ];

    return (
      <div style={{ padding: "0 20px" }}>
        <ModalLlenarEvaluacion
          visible={this.state.modalLlenarVisible}
          evaluacionId={this.state.evaluacionActivaId}
          onCancel={this.cerrarLlenar}
          onExito={this.onExitoLlenado}
        />

        <ModalVerEvaluacion
          visible={this.state.modalVerVisible}
          evaluacionId={this.state.evaluacionActivaId}
          onCancel={this.cerrarVer}
        />

        <ModalItem
          title="Nueva Evaluación de Proveedor"
          visible={this.state.modalNuevaVisible}
          onCancel={this.cerrarNueva}
          spinning={false}
          width={560}
        >
          <div style={{ marginBottom: 12 }}>
            <Text style={{ display: "block", marginBottom: 4 }}>
              Tipo de Proveedor
            </Text>
            <SelectItem
              allowClear
              placeholder="Todos los tipos"
              value={this.state.tipoProveedorFiltroId}
              onChange={this.cambiarTipoProveedorFiltro}
              style={{ width: "100%" }}
              options={(this.state.tiposDeProveedor || []).map((t) => ({
                value: t._id,
                label: t.descripcion ? `${t.nombre} - ${t.descripcion}` : t.nombre,
              }))}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <Text style={{ display: "block", marginBottom: 4 }}>Proveedor</Text>
            <SelectProveedoresItem
              headersToken={this.props.headersToken}
              empresaId={this.props.empresaId}
              tipoProveedorId={this.state.tipoProveedorFiltroId}
              value={this.state.proveedorNuevoId}
              onChange={(value) => this.setState({ proveedorNuevoId: value })}
              style={{ width: "100%" }}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <Text style={{ display: "block", marginBottom: 4 }}>Plantilla Autorizada</Text>
            <SelectPlantillasEvaluacionItem
              headersToken={this.props.headersToken}
              empresaId={this.props.empresaId}
              tipoProveedorId={this.state.tipoProveedorFiltroId}
              value={this.state.plantillaNuevaId}
              onChange={(value) => this.setState({ plantillaNuevaId: value })}
              style={{ width: "100%" }}
            />
          </div>

          <Space style={{ width: "100%", marginBottom: 12 }} size={12}>
            <div style={{ flex: 1 }}>
              <Text style={{ display: "block", marginBottom: 4 }}>Frecuencia</Text>
              <SelectItem
                options={FRECUENCIAS}
                value={this.state.frecuenciaNueva}
                onChange={(value) => this.setState({ frecuenciaNueva: value })}
                style={{ width: "100%" }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Text style={{ display: "block", marginBottom: 4 }}>
                Día del mes (para "Crear")
              </Text>
              <InputNumberItem
                min={1}
                max={31}
                value={this.state.diaNuevo}
                onChange={(value) => this.setState({ diaNuevo: value })}
                style={{ width: "100%" }}
              />
            </div>
          </Space>

          <div style={{ marginBottom: 4 }}>
            <Text style={{ display: "block", marginBottom: 4 }}>
              Notificar a (opcional, para "Crear")
            </Text>
            <SelectItem
              allowClear
              placeholder="Nadie"
              style={{ width: "100%" }}
              value={this.state.usuarioNotificarNuevoId ?? undefined}
              onChange={(value) => this.setState({ usuarioNotificarNuevoId: value ?? null })}
            >
              {this.state.usuariosEmpresa.map((u) => (
                <Select.Option key={u._id} value={u._id}>
                  {`${u.nombre} ${u.apellidoPaterno ?? ""} ${u.apellidoMaterno ?? ""}`.trim()}
                </Select.Option>
              ))}
            </SelectItem>
          </div>

          <Text type="secondary" style={{ fontSize: 12, display: "block", marginTop: 8 }}>
            <b>Crear</b> solo programa el recordatorio en el proveedor (también lo ves y editas
            desde la pestaña "Evaluación de Proveedores" del proveedor). <b>Crear y Llenar</b>{" "}
            genera la evaluación ahora mismo para llenarla en este momento.
          </Text>

          <div style={{ textAlign: "right", marginTop: 16, marginBottom: 2 }}>
            <ButtonItem onClick={this.cerrarNueva} rojo style={{ marginRight: 8 }}>
              Cancelar
            </ButtonItem>
            <ButtonItem
              onClick={this.crearProgramacion}
              loading={this.state.creandoProgramacion}
              style={{ marginRight: 8 }}
            >
              Crear
            </ButtonItem>
            <ButtonItem verde onClick={this.crearEvaluacion} loading={this.state.creando}>
              Crear y Llenar
            </ButtonItem>
          </div>
        </ModalItem>

        <PageHeader
          title="Evaluación de Proveedores"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 0,
            borderRadius: "6px 6px 0 0",
          }}
          extra={
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <ButtonItem
                className="botonAgregar"
                azul
                icon={<PlusOutlined />}
                onClick={this.abrirNueva}
              >
                Nueva Evaluación
              </ButtonItem>
              <HeaderActions>
                {this.props.permisoVerReportesEvaluacion && (
                  <ButtonItem
                    className="botonAgregar"
                    morado
                    icon={<BarChartOutlined />}
                    onClick={() =>
                      this.props.history.push("/panel/evaluacionProveedoresReportes")
                    }
                  >
                    Ver Reportes
                  </ButtonItem>
                )}
                {this.props.permisoConfiguracionEvaluacionProveedores && (
                  <ButtonItem
                    className="botonAgregar"
                    blanco
                    icon={<SettingOutlined />}
                    onClick={() =>
                      this.props.history.push("/panel/evaluacionProveedoresConfiguracion")
                    }
                  >
                    Configuración
                  </ButtonItem>
                )}
              </HeaderActions>
            </div>
          }
        />

        <SubHeaderItem>
          <SelectProveedoresItem
            headersToken={this.props.headersToken}
            empresaId={this.props.empresaId}
            allowClear
            placeholder="Filtrar por proveedor"
            value={this.state.filtroProveedorId}
            onChange={this.handleFiltroProveedorChange}
            style={{ width: 200 }}
          />
          <SelectItem
            allowClear
            placeholder="Filtrar por tipo de proveedor"
            value={this.state.filtroTipoProveedorId}
            onChange={this.handleFiltroTipoProveedorChange}
            style={{ width: 200 }}
            options={(this.state.tiposDeProveedor || []).map((t) => ({
              value: t._id,
              label: t.descripcion ? `${t.nombre} - ${t.descripcion}` : t.nombre,
            }))}
          />
          <SelectPlantillasEvaluacionItem
            headersToken={this.props.headersToken}
            empresaId={this.props.empresaId}
            allowClear
            placeholder="Filtrar por plantilla"
            value={this.state.filtroPlantillaId}
            onChange={this.handleFiltroPlantillaChange}
            style={{ width: 200 }}
          />
          <RangePickerItem
            placeholder={["Fecha inicio", "Fecha fin"]}
            allowClear
            value={this.state.fechaFiltro}
            onChange={this.handleFechaChange}
            style={{ width: 240 }}
          />
          <SegmentedItem
            options={[
              { label: "Pendientes", value: "pendiente" },
              { label: "Borrador", value: "borrador" },
              { label: "Completadas", value: "completada" },
              { label: "Todas", value: "todas" },
            ]}
            value={this.state.estadoFiltro}
            onChange={this.handleEstadoChange}
          />
        </SubHeaderItem>

        <TableItemDinamico
          onRef={(node) => (this.tableRef = node)}
          columns={columnas}
          dataSource={this.state.evaluaciones}
          loading={this.state.loading}
          totalRecords={this.state.totalRecords}
          onFetchData={this.fetchData}
          rowKey="_id"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoConfiguracionEvaluacionProveedores:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a726d3e84bfe1e26a3e4c6a",
    )?.activado,
  permisoVerReportesEvaluacion:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a726d5a84bfe1e26a3e4cfc",
    )?.activado,
});

export default connect(mapStateToProps)(EvaluacionProveedores);
